import type { CodeBlockProps } from '@components/code-block/code-block.view';
import CodeBlock from '@components/code-block/code-block.view';

export default CodeBlock;
export type { CodeBlockProps };
